export const PROJECT_DASHBOARD_CONFIG = {
    name            : 'Dashboard',
    icon            : 'i5-dashboard',
    // iconLight       : 'i5-dashboard', //'i5-dashboard-light',
    image           : 'dashboard',
    iconSvg         : 'isvg-view-dashboard',
    url             : 'dashboard',
    stringId        : 'dashboard',
    description     : 'View and manage project dashboard.',
    menuName        : 'Dashboard',
    inheritance     : false,
    hasTemplates    : false,
    canBeInProject  : true,
}
